import Login from 'core/Login/Login';
export default Login;
